import { RenderUnsettledUI } from 'shared/components';
import { useGetWorkerList } from 'hq/hooks/queryHooks/flexWorkers/use-get-flex-worker-list';
import { useState } from 'react';
import { useDebounce } from 'shared/hooks/use-debounce';
import { AutocompleteOption } from 'redesign';
import { PaymentsFiltersDataProviderProps } from './payments-filters.types';
import { PaymentsFilters } from './payments-filters';
import { useGetFlexWorker } from '../../../../../hooks/queryHooks/flexWorkers/useGetFlexWorker';
import { WorkerList } from '../../../../../services/flex-worker-service.types';
import { HQGetFlexWorkerDetailsResponse } from '../../../../../../types';

export const PaymentsFiltersDataProvider = ({
  toggleFilters,
  handleFiltersChange,
  appliedFilters,
  isOpen,
}: PaymentsFiltersDataProviderProps) => {
  const [flexWorkerSelectedOption, setFlexWorkerSelectedOption] =
    useState<AutocompleteOption | null>(null);
  const [flexWorkerSearchValue, setFlexWorkerSearchValue] = useState('');
  const debouncedFlexWorkerSearchValue = useDebounce(flexWorkerSearchValue, 300);

  const workersQuery = useGetWorkerList(debouncedFlexWorkerSearchValue);
  const singleWorkerQuery = useGetFlexWorker(appliedFilters.workerId);

  if (appliedFilters.workerId && singleWorkerQuery.status !== 'success') {
    return <RenderUnsettledUI data={singleWorkerQuery} />;
  }

  if (!isOpen) {
    return null;
  }

  return (
    <PaymentsFilters
      toggleFilters={toggleFilters}
      appliedFilters={appliedFilters}
      isOpen={isOpen}
      handleFiltersChange={handleFiltersChange}
      filterData={{
        workers: workersQuery.data || [],
      }}
      selectedWorkerData={singleWorkerQuery.data && getWorkerLabel(singleWorkerQuery.data)}
      flexWorkerOption={flexWorkerSelectedOption}
      setFlexWorkerOption={setFlexWorkerSelectedOption}
      flexWorkerSearch={flexWorkerSearchValue}
      setFlexWorkerSearch={setFlexWorkerSearchValue}
    />
  );
};

const getWorkerLabel = (worker: HQGetFlexWorkerDetailsResponse): WorkerList => {
  return {
    workerId: worker.id,
    email: worker.email,
    firstName: worker.firstName ?? '',
    infix: worker.infix ?? '',
    lastName: worker.lastName ?? '',
  };
};
